export const accuracyToBand = (accuracy: number) => {
  if (accuracy >= 0.9) {
    return "High Accuracy";
  }
  if (accuracy >= 0.8) {
    return "Medium Accuracy";
  }

  return "Low Accuracy";
};

export const accuracyToColor = (accuracy: number) => {
  if (accuracy >= 0.9) {
    return "#6AC784";
  }
  if (accuracy >= 0.8) {
    return "#EEBA7E";
  }

  return "#EE7E7E";
};

export default accuracyToBand;
